import { Link } from 'react-router-dom';

const stats = [
  { value: '1,200+', label: '收录剧集', icon: 'ri-file-list-3-line' },
  { value: '每日', label: '更新追踪', icon: 'ri-calendar-check-line' },
  { value: '6 大', label: '地区覆盖', icon: 'ri-earth-line' },
  { value: '100%', label: '剧情可读', icon: 'ri-book-open-line' },
];

export default function HomeIntro() {
  return (
    <section className="bg-secondary-800 text-secondary-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-semibold md:text-3xl">
              关于「善良的小姨子在线」
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 md:text-base">
              我们是一个专注热门电视剧的在线观看与剧情介绍平台。无论你是想找一部下饭剧，还是想紧跟最新剧集的更新进度，这里都能帮你快速找到答案。我们整理每部剧的剧情简介、主演阵容与集数更新情况，让追剧这件小事更省心。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始追剧
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-500 px-5 py-2.5 text-sm font-medium text-secondary-50 transition-colors hover:bg-secondary-700 cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg border border-secondary-700 bg-secondary-900/40 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <p className="mt-3 font-heading text-xl font-bold text-secondary-50 md:text-2xl">
                  {s.value}
                </p>
                <p className="mt-1 text-xs text-secondary-300 md:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}